// extracted by mini-css-extract-plugin
export default {"container":"TrailerPelicula_container__ksVIn"};